/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthChallengeResponse as ModelsAuthenticationAuthChallengeResponse } from '../models/Models/Authentication/auth-challenge-response';
import { AuthLoginResponse as ModelsAuthenticationAuthLoginResponse } from '../models/Models/Authentication/auth-login-response';
import { AuthTokenResponse as ModelsAuthenticationAuthTokenResponse } from '../models/Models/Authentication/auth-token-response';
import { v3TokenAuthorizePost$Json$Json } from '../fn/token-authorization/v-3-token-authorize-post-json-json';
import { V3TokenAuthorizePost$Json$Json$Params } from '../fn/token-authorization/v-3-token-authorize-post-json-json';
import { v3TokenAuthorizePost$Json$Plain } from '../fn/token-authorization/v-3-token-authorize-post-json-plain';
import { V3TokenAuthorizePost$Json$Plain$Params } from '../fn/token-authorization/v-3-token-authorize-post-json-plain';
import { v3TokenAuthorizePost$Json$Xml } from '../fn/token-authorization/v-3-token-authorize-post-json-xml';
import { V3TokenAuthorizePost$Json$Xml$Params } from '../fn/token-authorization/v-3-token-authorize-post-json-xml';
import { v3TokenAuthorizePost$Xml$Json } from '../fn/token-authorization/v-3-token-authorize-post-xml-json';
import { V3TokenAuthorizePost$Xml$Json$Params } from '../fn/token-authorization/v-3-token-authorize-post-xml-json';
import { v3TokenAuthorizePost$Xml$Plain } from '../fn/token-authorization/v-3-token-authorize-post-xml-plain';
import { V3TokenAuthorizePost$Xml$Plain$Params } from '../fn/token-authorization/v-3-token-authorize-post-xml-plain';
import { v3TokenAuthorizePost$Xml$Xml } from '../fn/token-authorization/v-3-token-authorize-post-xml-xml';
import { V3TokenAuthorizePost$Xml$Xml$Params } from '../fn/token-authorization/v-3-token-authorize-post-xml-xml';
import { v3TokenGet$Json } from '../fn/token-authorization/v-3-token-get-json';
import { V3TokenGet$Json$Params } from '../fn/token-authorization/v-3-token-get-json';
import { v3TokenGet$Plain } from '../fn/token-authorization/v-3-token-get-plain';
import { V3TokenGet$Plain$Params } from '../fn/token-authorization/v-3-token-get-plain';
import { v3TokenGet$Xml } from '../fn/token-authorization/v-3-token-get-xml';
import { V3TokenGet$Xml$Params } from '../fn/token-authorization/v-3-token-get-xml';
import { v3TokenPost$Json$Json } from '../fn/token-authorization/v-3-token-post-json-json';
import { V3TokenPost$Json$Json$Params } from '../fn/token-authorization/v-3-token-post-json-json';
import { v3TokenPost$Json$Plain } from '../fn/token-authorization/v-3-token-post-json-plain';
import { V3TokenPost$Json$Plain$Params } from '../fn/token-authorization/v-3-token-post-json-plain';
import { v3TokenPost$Json$Xml } from '../fn/token-authorization/v-3-token-post-json-xml';
import { V3TokenPost$Json$Xml$Params } from '../fn/token-authorization/v-3-token-post-json-xml';
import { v3TokenPost$Xml$Json } from '../fn/token-authorization/v-3-token-post-xml-json';
import { V3TokenPost$Xml$Json$Params } from '../fn/token-authorization/v-3-token-post-xml-json';
import { v3TokenPost$Xml$Plain } from '../fn/token-authorization/v-3-token-post-xml-plain';
import { V3TokenPost$Xml$Plain$Params } from '../fn/token-authorization/v-3-token-post-xml-plain';
import { v3TokenPost$Xml$Xml } from '../fn/token-authorization/v-3-token-post-xml-xml';
import { V3TokenPost$Xml$Xml$Params } from '../fn/token-authorization/v-3-token-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class TokenAuthorizationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3TokenGet()` */
  static readonly V3TokenGetPath = '/v3/token';

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3TokenGet$Plain$Response(params?: V3TokenGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
    return v3TokenGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3TokenGet$Plain(params?: V3TokenGet$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthTokenResponse> {
    return this.v3TokenGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>): ModelsAuthenticationAuthTokenResponse => r.body)
    );
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3TokenGet$Json$Response(params?: V3TokenGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
    return v3TokenGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3TokenGet$Json(params?: V3TokenGet$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthTokenResponse> {
    return this.v3TokenGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>): ModelsAuthenticationAuthTokenResponse => r.body)
    );
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3TokenGet$Xml$Response(params?: V3TokenGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
    return v3TokenGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3TokenGet$Xml(params?: V3TokenGet$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthTokenResponse> {
    return this.v3TokenGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>): ModelsAuthenticationAuthTokenResponse => r.body)
    );
  }

  /** Path part for operation `v3TokenPost()` */
  static readonly V3TokenPostPath = '/v3/token';

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenPost$Json$Plain$Response(params?: V3TokenPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v3TokenPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenPost$Json$Plain(params?: V3TokenPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v3TokenPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenPost$Json$Json$Response(params?: V3TokenPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v3TokenPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenPost$Json$Json(params?: V3TokenPost$Json$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v3TokenPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenPost$Json$Xml$Response(params?: V3TokenPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v3TokenPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenPost$Json$Xml(params?: V3TokenPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v3TokenPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenPost$Xml$Plain$Response(params?: V3TokenPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v3TokenPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenPost$Xml$Plain(params?: V3TokenPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v3TokenPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenPost$Xml$Json$Response(params?: V3TokenPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v3TokenPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenPost$Xml$Json(params?: V3TokenPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v3TokenPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenPost$Xml$Xml$Response(params?: V3TokenPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v3TokenPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenPost$Xml$Xml(params?: V3TokenPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v3TokenPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /** Path part for operation `v3TokenAuthorizePost()` */
  static readonly V3TokenAuthorizePostPath = '/v3/token/authorize';

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenAuthorizePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenAuthorizePost$Json$Plain$Response(params?: V3TokenAuthorizePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v3TokenAuthorizePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenAuthorizePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenAuthorizePost$Json$Plain(params?: V3TokenAuthorizePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v3TokenAuthorizePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenAuthorizePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenAuthorizePost$Json$Json$Response(params?: V3TokenAuthorizePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v3TokenAuthorizePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenAuthorizePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenAuthorizePost$Json$Json(params?: V3TokenAuthorizePost$Json$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v3TokenAuthorizePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenAuthorizePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenAuthorizePost$Json$Xml$Response(params?: V3TokenAuthorizePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v3TokenAuthorizePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenAuthorizePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3TokenAuthorizePost$Json$Xml(params?: V3TokenAuthorizePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v3TokenAuthorizePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenAuthorizePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenAuthorizePost$Xml$Plain$Response(params?: V3TokenAuthorizePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v3TokenAuthorizePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenAuthorizePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenAuthorizePost$Xml$Plain(params?: V3TokenAuthorizePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v3TokenAuthorizePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenAuthorizePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenAuthorizePost$Xml$Json$Response(params?: V3TokenAuthorizePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v3TokenAuthorizePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenAuthorizePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenAuthorizePost$Xml$Json(params?: V3TokenAuthorizePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v3TokenAuthorizePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3TokenAuthorizePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenAuthorizePost$Xml$Xml$Response(params?: V3TokenAuthorizePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v3TokenAuthorizePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3TokenAuthorizePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3TokenAuthorizePost$Xml$Xml(params?: V3TokenAuthorizePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v3TokenAuthorizePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

}
